import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import React from 'react'
import BaseButton from './BaseButton'

interface SkipButtonProps {
  onClick: () => void
}

const SkipButton: React.FC<SkipButtonProps> = ({ onClick }) => {
  return (
    <BaseButton onClick={onClick}>
      Continue
      <ChevronRightIcon
        style={{
          fontSize: '20px'
        }}
      />
    </BaseButton>
  )
}

export default SkipButton
